var _ = require('underscore'),
  Promise = require('bluebird'),
  React = require('react'),
  Collapse = require('react-bootstrap/lib/Collapse'),
  Nav = require('react-bootstrap/lib/Nav'),
  NavItem = require('react-bootstrap/lib/NavItem'),
  Glyphicon = require('react-bootstrap/lib/Glyphicon'),
  ClassNames = require('classnames');

var Button = require('../button.jsx'),
  CustomPropTypes = require('../types.jsx'),
  Utils = require('../utils.jsx');

var MobilePlaylistsMenu = React.createClass({
  propTypes: {
    playlists: CustomPropTypes.PlaylistsType,
    playlist: React.PropTypes.number,
    onSelect: React.PropTypes.func,

    className: CustomPropTypes.ClassNameType
  },
  getInitialState: function () {
    return {
      'show': false
    };
  },
  render: function () {
    var self = this,
      playlists = this.props.playlists,
      playlist = playlists[this.props.playlist],
      playlists_menu_items = _.chain(playlists)
        .filter(function (playlist) {
          return !playlist.hide;
        })
        .map(function (playlist, index) {
          var icon = (playlist.image) ? <img src={playlist.image} className='player-playlist-image' /> : <Glyphicon glyph='play' />;
          return (
            <NavItem key={index} eventKey={index} href='javascript:void(0)' className='player-playlist'>
              {icon}
              {' '}
              {playlist.name}
            </NavItem>
          );
        })
        .value(),
      className = Utils.ClassNames('player-playlists', 'player-playlists-mobile', this.props.className),
      showClassNames = Utils.ClassNames('animated', 'fadeInLeftBig'),
      hideClassNames = Utils.ClassNames('animated', 'fadeOutLeftBig'),
      toggle = function () {
        self.setState({show: !self.state.show});
      };
    return (<div className={ClassNames(className)}>
      <Button role='playlist'
        icon='list'
        className={['player-btn-playlists']}
        onClick={toggle} />
      <Collapse in={this.state.show}
        dimension='width'
        timeout={5000}>
        <div>
          <div className='backdrop' onClick={toggle} />
          <Nav bsStyle='pills'
            stacked
            activeKey={this.props.playlist}
            onSelect={this.props.onSelect}
            onClick={toggle}>
            {playlists_menu_items}
          </Nav>
        </div>
      </Collapse>
    </div>);
  }
});

module.exports = MobilePlaylistsMenu;



// WEBPACK FOOTER //
// ./src/app/components/playlist/mobile-menu.jsx